// Load google maps api.



(function ($, Drupal, drupalSettings, GMaps) {
  'use strict';
  Drupal.behaviors.googleMaps = {
    loadMap: function (target) {
      // Load map settings.
      var map_data = drupalSettings.tnv_google_maps[$(target).data('mapid')];

      var gmap = new GMaps({
        div: target,
        lat: map_data.latitude,
        lng: map_data.longitude,
        zoom: parseInt(drupalSettings.tnv_google_maps.settings.zoom),
        disableDefaultUI: true,
        scaleControl: false,
        scrollwheel: false
      });

      gmap.addStyle({
        styledMapName: 'Styled Map',
        styles: JSON.parse(drupalSettings.tnv_google_maps.settings.style),
        mapTypeId: 'map_style'
      });
      gmap.setStyle('map_style');

      if (map_data.markers.length) {
        // Load map markers.
        map_data.markers.forEach(function (arrayItem) {
          gmap.addMarker({
            lat: arrayItem.latitude,
            lng: arrayItem.longitude,
            infoWindow: {
              content: arrayItem.infoHTML
            },
            icon: drupalSettings.tnv_google_maps.settings.default_pin
          });
        });
      }
    },
    attach: function () {
      var parent = this;
      var selected = $('.field-google-maps:not(.processed)');
      var mapfired = false;
      if (selected.length) {
        selected.addClass('processed').each(function () {
          $(selected).on('click', function () {
            if (mapfired === false) {
              mapfired = true;
              $('.map-overlay').hide();
              parent.loadMap(this);
            }
          });
        });
      }
    }
  };
})(jQuery, Drupal, drupalSettings, GMaps);
